import { Component, OnInit,OnDestroy ,ElementRef, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SharedService } from '../../services/Shared/Shared.service'; 
import { AuthService } from '../../services/auth/auth.service.service';
import { UserService } from '../../services/user/user.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { Renderer2 } from '@angular/core';
import { NewsService } from '../../services/news/news.service';
import { EventService } from '../../services/event/event.service';
import { ProductService } from '../../services/product/product.service';
import { RepositoryService } from '../../services/repository/repository.service';
import { LoaderService } from '../../services/shared/loader.service';
import { EMPTY } from 'rxjs';

declare interface RouteInfo {
  path: string;
  title: string;
  icon: string;
  class: string;
  allowedRole: number[];
  isSearch: boolean;
}
export const ROUTES: RouteInfo[] = [
  //{ path: '/site/dashboard', title: 'Dashboard',  icon: 'person', class: '', allowedRole: [1,2,3,4] },
  //{ path: '/site/news', title: 'News',  icon:'fa fa-bullhorn', class: '', allowedRole: [1,2,3,4] },
  //{ path: '/site/event', title: 'Event',  icon:'fa fa-calendar-check-o', class: '', allowedRole: [1,2,3,4] },
  //{ path: '/site/product', title: 'CI Landscape',  icon:'fa fa-product-hunt', class: '', allowedRole: [1,2,3,4] },
  //{ path: '/site/repository', title: 'Repository',  icon:'fa fa-database', class: '', allowedRole: [1,2,3,4] },
  //{ path: '/site/timelines', title: 'Trial Timelines',  icon:'fa fa-hourglass-end', class: '', allowedRole: [1,2,3,4] },
  //{ path: '/site/company', title: 'Company',  icon:'fa fa-building-o', class: '', allowedRole: [1,2,3,4] }
];


@Component({
  selector: 'app-site-layout', 
  templateUrl: './site-layout.component.html',
  styleUrls: ['./site-layout.component.css']
})

export class SiteLayoutComponent implements OnInit,OnDestroy  { 
  
  public SaveButton = false;
  @ViewChild('ErrorMessageDiv') errorMessageDiv: ElementRef;
  @ViewChild('ErrorMessageValue') errorMessageValue: ElementRef;
  @ViewChild('closebutton') closebutton;
  // ngOnInit() {
  //   // if (window.screen.width === 360) { // 768px portrait
  //   //   this.isShow = true;
  //   // }
  //   isShow = true;
  //   window.onresize = () => this.isShow = window.innerWidth > 991;
  // }
  //isShow = true;
  // toggleDisplay() {
  //   this.isShow = !this.isShow;
  // }
  
  public copyRightsDate : Date = new Date();

  menuItems: any[];
  search: string;
  dropdownSettings: IDropdownSettings = {};
  Indications: any;
  public NotificationData:any;
  public FullTextSearchData:any = [];
  public NewsSearchData:any = [];
  public ProductsSearchData:any = [];
  public EventsSearchData:any = [];
  public RepoSearchData:any = [];
  public isSearchData = true;
  public selectedItems = [];
  public NewsResponse;
  public EventResponse;
  public ProductResponse;
  public RepoResponse;
  public CompanyResponse;
  public toggle: Boolean = false;
  public searchInput:String = '';  
  public searchResult: Array<any> = [];
  public CompanyIndustry = "";
  public LoginCompanyId = this.sharedService.getUserDetail('CompanyId');
  public CompanyLogo = "../assets/img/Company/"+ this.LoginCompanyId +"/logo.png";
  constructor(
    private router: Router,
    private sharedService : SharedService,
    private authService : AuthService,
    private userService: UserService,
    private renderer: Renderer2,
    private newsService: NewsService,
    private eventService: EventService,
    private productService: ProductService,
    private repoService: RepositoryService,
    private route: ActivatedRoute,
    public loaderService: LoaderService,
    ) { }

    public NotificationCount = 0;
    public NewsCount = 0
    public EventCount = 0
    public AdminReplyCount = 0
    public NewsIndicationCount = 0
    public EventIndicationCount = 0
    public RepoIndicationCount = 0
    public ProductIndicationCount = 0
    public NewsCategorizationCount = 0
    public notificationResult:any = []
    response: any = [];
    public NotificationReq = {
      UserID : this.sharedService.getUserDetail('Userid'),
      NotificationDate : this.sharedService.getUserDetail('NotificationDate'),
      Type : null,
      RoleId : this.sharedService.getUserDetail('RoleId'), 
      CompanyId : this.sharedService.getUserDetail('CompanyId'),
      Competitors : [],
      AlertIndication : this.sharedService.getUserDetail('AlertIndication')
    }

    public userRequest = {  
      UserID : this.sharedService.getUserDetail('Userid'),
      CompetitorID : [],
      LogStats : false,
      ClientID : this.sharedService.getUserDetail('CompanyId'),
      CompanyIndustry: this.sharedService.getUserDetail('CompanyIndustry'),
      CompanyId: ""
    }

    public userRepoRequest = {
      UserID : this.sharedService.getUserDetail('Userid'),
      ClientID : [],
      LogStats : false
    }   
    

    public accountmodel:any = {
      ID: '',
      FirstName: '',
      LastName: '',     
      EmailAddress: '',
      Password : '',
      IsEmailAlert: false,
      ModifiedBy: null,
      AlertIndication : []
    }
   
    public userID = "";
    public userArray: any;
    public dropdownList:any;

    public FirstName = '';
    public LastName = '';
    public AlertMessage = ''
   
  showMyContainer: boolean = true;
  public isMobileLayout = true;
  public isAlertHidden: boolean = false;
  
  ngOnInit(): void {  
          
    $('.toggle-btn').click(function() {
      $(".sidebar").toggleClass('show-menu');
    });
      
    this.CompanyIndustry = this.sharedService.getUserDetail('CompanyIndustry');
    this.FirstName = this.sharedService.getUserDetail('Firstname');
    this.LastName = this.sharedService.getUserDetail('LastName');
    this.AlertMessage = this.sharedService.getUserDetail('AlertMessage');
    if(this.AlertMessage == 'undefined' || this.AlertMessage == 'null' || this.AlertMessage == null){
      this.AlertMessage = '';
    }
    
    if(this.sharedService.FullTextSearchData.length > 0){
        this.isSearchData = false;
    }

    //Get Competirors Ids
    for (var i = 0; i < this.sharedService.getUserDetail('CompetitorID').length; i++) {
      this.userRequest.CompetitorID.push(this.sharedService.getUserDetail('CompetitorID')[i])
    }
    this.userRepoRequest.ClientID.push(this.sharedService.getUserDetail('CompanyId'))   
    if(this.CompanyIndustry.trim() == "MarketResearch"){
      this.userRequest.CompanyId = this.sharedService.getUserDetail('CompanyId')  
      this.isAlertHidden = true;
    }
    //console.log(this.userRequest);


    //Get Site Modules/items link for user 
    let siteMenu = [];
    siteMenu = this.sharedService.getSiteMenu('SiteModules');
    //console.log(siteMenu.length)
    ROUTES.length = 0;
    for (var i = 0; i < siteMenu.length; i++) {
      ROUTES.push(siteMenu[i]);
    }
    this.menuItems = ROUTES.filter(menuItem => menuItem.allowedRole.includes(Number(this.sharedService.getUserDetail('RoleId'))));

    //Fulltext Search feature
   
    this.newsService.GetUserNews(this.userRequest).subscribe(result => {
      // console.log(result)
      if (result) {
        this.NewsResponse = result;        
        if(this.isSearchData){
        for (var i = 0; i < this.NewsResponse.length; i++) {
          this.NewsSearchData.push(
            {
              Module : 'News',
              Id : this.NewsResponse[i]._id,
              SearchKey : 'Title',
              SearchData : this.NewsResponse[i].Title
            }
          )           

        }
        if(this.NewsSearchData.length > 0)
        {
          this.sharedService.SetFullTextData(this.NewsSearchData);          
        }
       
      }        
      }
    }, error => {      
      console.log(error)
    });

    this.eventService.GetUserEvent(this.userRequest).subscribe(result => {
      // console.log(result)
      if (result) {
        this.EventResponse = result; 
        if(this.isSearchData){
        for (var i = 0; i < this.EventResponse.length; i++) {
          this.EventsSearchData.push(
            {
              Module : 'Event',
              Id : this.EventResponse[i]._id,
              SearchKey : 'EventTopic',
              SearchData : this.EventResponse[i].EventTopic
            }
          )
        }
        if(this.EventsSearchData.length > 0)
        {
          this.sharedService.SetFullTextData(this.EventsSearchData);          
        }  
      }
      }
    }, error => {      
      console.log(error)
    });

    this.repoService.GetUserRepo(this.userRepoRequest).subscribe(result => {
      // console.log(result)
      if (result) {
        this.RepoResponse = result;
       
        if(this.isSearchData){
        for (var i = 0; i < this.RepoResponse.length; i++) {
          this.RepoSearchData.push(
            {
              Module : 'Repository',
              Id : this.RepoResponse[i]._id,
              SearchKey : 'Title',
              SearchData : this.RepoResponse[i].Title
            }
          )
        }
        if(this.RepoSearchData.length > 0)
        {
          this.sharedService.SetFullTextData(this.RepoSearchData);          
        } 
      }
      }
    }, error => {      
      console.log(error)
    });

    this.productService.GetUserProduct(this.userRequest).subscribe(result => {
      if (result) {
        this.ProductResponse = result;
    
        if(this.isSearchData){
          for (var i = 0; i < this.ProductResponse.length; i++) {
            this.ProductsSearchData.push(
              {
                Module : 'Product',
                Id : this.ProductResponse[i]._id,
                SearchKey : 'Name',
                SearchData : this.ProductResponse[i].Name
              }
            )
          }
          if(this.ProductsSearchData.length > 0) {
            this.sharedService.SetFullTextData(this.ProductsSearchData);          
          } 
        }    
      }
    }, error => {      
      console.log(error)
    });
    
    
    this.FullTextSearchData = this.sharedService.FullTextSearchData;
    this.NotificationReq.NotificationDate = this.sharedService.getUserDetail('NotificationDate')
    sessionStorage.setItem('NotificationDate',"")
    for (var i = 0; i < this.sharedService.getUserDetail('CompetitorID').length; i++) {
      this.NotificationReq.Competitors.push(this.sharedService.getUserDetail('CompetitorID')[i])
    }
    this.userService.GetUserNotification(this.NotificationReq).subscribe(result => {
      if(result){
          this.NotificationData = result
          this.NotificationCount = 0;
          var isNews = false;
          var isEvent = false;          
          var isAdminReply = false;
          var isNewsIndication = false;
          var isEventIndication = false;
          var isRepoIndication = false;
          var isNewsCategorization = false;
          var isProductIndication = false;
          if(this.NotificationData.length > 0)
          {
          for (var i = 0; i < this.NotificationData.length; i++) {
            this.NotificationCount += this.NotificationData[i].NotificationCount; 
            if(this.NotificationData[i].Type == "News")    
            {
              this.NewsCount += this.NotificationData[i].NotificationCount
              isNews = true;
            }   
            if(this.NotificationData[i].Type == "Event")    
            {
              this.EventCount += this.NotificationData[i].NotificationCount
              isEvent = true;
            }   
            if(this.NotificationData[i].Type == "AdminReply")    
            {
              this.AdminReplyCount += this.NotificationData[i].NotificationCount
              isAdminReply = true;
            }   

            if(this.NotificationData[i].Type == "NewsIndication")    
            {
              this.NewsIndicationCount += this.NotificationData[i].NotificationCount
              isNewsIndication = true;
            }   
            if(this.NotificationData[i].Type == "NewsCategorization")    
            {
              this.NewsCategorizationCount += this.NotificationData[i].NotificationCount
              isNewsCategorization = true;
            }   
            if(this.NotificationData[i].Type == "EventIndication")    
            {
              this.EventIndicationCount += this.NotificationData[i].NotificationCount
              isEventIndication = true;
            }   
            if(this.NotificationData[i].Type == "RepoIndication")    
            {
              this.RepoIndicationCount += this.NotificationData[i].NotificationCount
              isRepoIndication = true;
            }  
            
            if(this.NotificationData[i].Type == "ProductIndication")    
            {
              this.ProductIndicationCount += this.NotificationData[i].NotificationCount
              isProductIndication = true;
            } 
          }
            if (isNews) {
              this.notificationResult.push({
                type: "News",
                message: "Check out News, " + this.NewsCount + " latest news available",
              }

              )
            }

          if(isEvent)
          {
            this.notificationResult.push({
              type : "Event",
              message : "Check out Event, " + this.EventCount + " latest events available",           
            }        
         
          )
          }
          if(isAdminReply)
          {
            this.notificationResult.push({
              type : "AdminReply",
              message : "Admin responded to your comments.",           
            }        
         
          )
        }

            if (isNewsIndication) {
              this.notificationResult.push({
                type: "NewsIndication",
                message : "Check out News, " + this.NewsIndicationCount + " news available based on preferred Indications.", 
              }

              )
            }
            if (isNewsCategorization) {
              this.notificationResult.push({
                type: "NewsCategorization",
                message : "Check out News, " + this.NewsCategorizationCount + " news available based on preferred Theraphy Area.", 
              }

              )
            }
            if (isEventIndication) {
              this.notificationResult.push({
                type: "EventIndication",
                message : "Check out Event, " + this.EventIndicationCount + " event available based on preferred Indications.", 
              }

              )
            }
            if (isRepoIndication) {
              this.notificationResult.push({
                type: "RepoIndication",
                message : "Check out Repository, " + this.RepoIndicationCount + " repository available based on preferred Indications.", 
              }

              )
            }

            if (isProductIndication) {
              this.notificationResult.push({
                type: "ProductIndication",
                message : "Check out Products, " + this.ProductIndicationCount + " product available based on preferred Indications.", 
              }

              )
            }
        
      }
      }    
    }, error => {
      console.log(error)
    });

  }

  signout(){
    var CompanyId = this.sharedService.getUserDetail('CompanyId');
    if(this.sharedService.getUserDetail('Userid') != undefined && this.sharedService.getUserDetail('Userid') != ""){
      var LogOutData = {
        UserID : this.sharedService.getUserDetail('Userid')
      }    

      this.authService.SignOut(LogOutData).subscribe(result => {        
      })
    }
    this.sharedService.removeUserDetail();
    this.router.navigate(['./?c=' + CompanyId]);
  }
  ngOnDestroy() {
    console.log('Items destroyed');
  } 

  UpdateNotification (type)
  { 
    
    if(type == "News")
    {
      this.NotificationCount -= this.NewsCount
      this.notificationResult = this.notificationResult.filter(xx => xx.type != "News")
      this.router.navigate(['../site/news']);
      this.NotificationReq.Type = "News";
      this.userService.UpdateUserNotification(this.NotificationReq).subscribe();      
    }
    else if(type == "Event")
    {
      this.NotificationCount -= this.EventCount
      this.notificationResult = this.notificationResult.filter(xx => xx.type != "Event")
      this.router.navigate(['../site/event']);
      this.NotificationReq.Type = "Event";
      this.userService.UpdateUserNotification(this.NotificationReq).subscribe();      
    }
    else if(type == "AdminReply")
    {
      this.NotificationCount -= this.AdminReplyCount
      this.notificationResult = this.notificationResult.filter(xx => xx.type != "AdminReply")
      // this.router.navigate(['../site/news']);
      this.NotificationReq.Type = "AdminReply";
      this.userService.UpdateUserNotification(this.NotificationReq).subscribe();      
    }else if(type == "NewsIndication")
    {
      this.NotificationCount -= this.NewsIndicationCount
      this.notificationResult = this.notificationResult.filter(xx => xx.type != "NewsIndication")
      this.router.navigate(['../site/news']);
      this.NotificationReq.Type = "NewsIndication";
      this.userService.UpdateUserNotification(this.NotificationReq).subscribe();      
    }
    else if(type == "NewsCategorization")
    {
      this.NotificationCount -= this.NewsCategorizationCount
      this.notificationResult = this.notificationResult.filter(xx => xx.type != "NewsCategorization")
      this.router.navigate(['../site/news']);
      this.NotificationReq.Type = "NewsCategorization";
      this.userService.UpdateUserNotification(this.NotificationReq).subscribe();      
    }
    else if(type == "EventIndication")
    {
      this.NotificationCount -= this.EventIndicationCount
      this.notificationResult = this.notificationResult.filter(xx => xx.type != "EventIndication")
      this.router.navigate(['../site/event']);
      this.NotificationReq.Type = "EventIndication";
      this.userService.UpdateUserNotification(this.NotificationReq).subscribe();      
    }else if(type == "RepoIndication")
    {
      this.NotificationCount -= this.RepoIndicationCount
      this.notificationResult = this.notificationResult.filter(xx => xx.type != "RepoIndication")
      this.router.navigate(['../site/repository']);
      this.NotificationReq.Type = "RepoIndication";
      this.userService.UpdateUserNotification(this.NotificationReq).subscribe();      
    }
    else if(type == "ProductIndication")
    {
      this.NotificationCount -= this.ProductIndicationCount
      this.notificationResult = this.notificationResult.filter(xx => xx.type != "ProductIndication")
      this.router.navigate(['../site/product']);
      this.NotificationReq.Type = "ProductIndication";
      this.userService.UpdateUserNotification(this.NotificationReq).subscribe();      
    }
  }

  GetData(){
     this.getAlertData();
     this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };
    this.userID = this.sharedService.getUserDetail('Userid');    
    this.userService.GetUserDetails(this.userID).subscribe(result => {
      this.userArray = result;
      //console.log(this.userArray[0].AlertIndication)
      this.accountmodel.ID = this.userID;
      this.accountmodel.FirstName = this.userArray[0].FirstName;
      this.accountmodel.LastName = this.userArray[0].LastName;
      this.accountmodel.EmailAddress = this.userArray[0].EmailAddress;
      this.accountmodel.Password = this.userArray[0].Password;
      this.accountmodel.IsEmailAlert = this.userArray[0].IsEmailAlert;
      this.accountmodel.ModifiedBy = this.userID;
      // this.accountmodel.AlertIndication = this.userArray[0].AlertIndication
      var AlertIndicationArray = this.userArray[0].AlertIndication;
      this.selectedItems=[];
      this.accountmodel.AlertIndication = [];
       for (var i = 0; i < AlertIndicationArray.length; i++) {
        this.accountmodel.AlertIndication.push({
          AlertType : AlertIndicationArray[i].AlertType,
          Value : AlertIndicationArray[i].Value
        });
        this.selectedItems.push(
          {
            item_id: AlertIndicationArray[i].Value+'±'+AlertIndicationArray[i].AlertType,
            item_text:AlertIndicationArray[i].Value
          }
        );
       }
    }, error => {
      console.log(error)
    })
  }

  onItemSelect(item: any) {
    this.accountmodel.AlertIndication.push({
      AlertType : item.item_id.split("±")[1],
      Value : item.item_text
    });
  }
  onSelectAll(item: any) {
    this.accountmodel.AlertIndication=[];
    for (let index = 0; index < item.length; index++) {
      this.accountmodel.AlertIndication.push({
        AlertType : item[index].item_id.split("±")[1],
        Value :  item[index].item_text
      });          
    }  
  }
  onItemDeSelect(item) {
      var deletedindex = this.findWithAttr(this.accountmodel.AlertIndication, item.item_text);
      this.accountmodel.AlertIndication.splice(deletedindex, 1);
    
  }
  findWithAttr(array, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i].Value === value) {
        return i;
      }
    }
    return -1;
  }
  onDeSelectAll(item) {
      this.accountmodel.AlertIndication = [];
  }
  
  getAlertData(): void {
    let tmp = [];
    this.sharedService.GetIndication().subscribe(result => {
      var r1:any = result;
      for (let i = 0; i < r1.length; i++) {
        tmp.push({ item_id: r1[i].Name+'±Indication', item_text: r1[i].Name});
      }     
    });
    this.sharedService.GetCategorization().subscribe(result => {
      var r2:any = result;    
      for (let i = 0; i < r2.length; i++) {
        tmp.push({ item_id: r2[i].Name+'±Categorization', item_text: r2[i].Name });
      } 
      this.dropdownList = tmp;     
    });    
  //  return tmp;
  }


  AccountDetailsSave() {
    this.SaveButton = true;
    //console.log(this.accountmodel)
    this.userService.UpdateUser(this.accountmodel).subscribe(result => {     
      if (result) {
        this.errorMessageDiv.nativeElement.style.display = 'block';
        this.errorMessageDiv.nativeElement.classList.remove('alert-danger');
        this.errorMessageDiv.nativeElement.classList.add('alert-success');
        this.renderer.setProperty(this.errorMessageValue.nativeElement, 'innerHTML', 'Details updated successfully !!');

        setTimeout(() => {
          this.errorMessageDiv.nativeElement.style.display = 'none';
          this.closebutton.nativeElement.click(); 
          this.SaveButton = false;         
        }, 2000);

      }
    }, error => {
      this.SaveButton = false;
      var r = error;
      this.errorMessageDiv.nativeElement.style.display = 'block';
      this.errorMessageDiv.nativeElement.classList.remove('alert-success');
      this.errorMessageDiv.nativeElement.classList.add('alert-danger');
      this.renderer.setProperty(this.errorMessageValue.nativeElement, 'innerHTML', r.reason);
      console.log(error)
    })
  }

  FetchSearchData(val) {
    if (val === '') {
      return this.searchResult = [];
    }
    this.searchResult = this.FullTextSearchData.filter((series) => {
      return series.SearchData.toLowerCase().includes(val.toLowerCase());
    })
    this.toggle = false;
  }

  showDetails(val){
    
    //Code to Track User Activity
    var TrackActivity = {
      UserID : this.sharedService.getUserDetail('Userid'),     
      LogStats : true,
      Module : "Full-Text-Search",
      Action : {
        ActionName : this.searchInput,
        ModuleID : ""
      }
    }
    this.sharedService.TrackActivity(TrackActivity).subscribe();
    //End of code

    this.toggle = true;
    this.searchInput = ""
    //console.log(val);
    
    sessionStorage.setItem('FullTextSearch', val.Id);
    if (val.Module === "News") {
      if(this.router.url == '/site/news'){
        //window.location.reload();
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigate(['./news'], { relativeTo: this.route });
      }
      else{
        this.router.navigate(['../site/news']);
      }
      
    }else if (val.Module === "Event") {
      this.router.navigate(['../site/event']);
    } 
    else if (val.Module === "Product") {
      this.router.navigate(['../site/product']);
    } 
    else if (val.Module === "Repository") {
      if(this.router.url == '/site/repository'){
        //window.location.reload();
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigate(['./repository'], { relativeTo: this.route });
      }
      else{
        this.router.navigate(['../site/repository']);
      }
    } 
   
  }
  ClosePopUp()  {}

  onClickedOutside(e: Event) {

    //Code to Track User Activity
    if(this.searchInput){
      var TrackActivity = {
        UserID : this.sharedService.getUserDetail('Userid'),     
        LogStats : true,
        Module : "Full-Text-Search",
        Action : {
          ActionName : this.searchInput,
          ModuleID : ""
        }
      }
      this.sharedService.TrackActivity(TrackActivity).subscribe();
    }
    //End of code
    
    this.toggle = false;
    this.searchResult = [];
    this.searchInput = ""
    // console.log('Clicked outside:');
  }
  


 
}
